import { type ReactElement } from 'react';
import { Button, Text } from '@cencosud-cencommerce/paris-uikit';

import { environment } from '@/modules/perseo-billing/environments/environment';
import { ConnectionDogIcon } from '@/modules/perseo-billing/ui/react/src';
import { redirectToUrl } from '@/modules/perseo-billing/utils/window';

interface BillingDniFallbackProps {
  message: string;
}

export const BillingDniFallback = ({
  message
}: BillingDniFallbackProps): ReactElement => {
  const handleGoHome = () => {
    redirectToUrl(environment.HOME_URL);
  };

  return (
    <div className="co-w-full co-h-full co-flex co-items-center co-justify-center co-overflow-hidden co-pt-10 tablet_w:co-py-8">
      <div className="co-w-full co-max-w-[500px] co-flex co-flex-col co-items-center co-justify-center co-gap-6 co-px-6 co-py-14 co--mt-10">
        <ConnectionDogIcon width={200} height={200} />

        <Text
          variant="body1"
          className="co-text-[#363F45] co-leading-6 co-text-center"
        >
          {message}
        </Text>

        <Button
          variant="primary"
          size="lg"
          onClick={handleGoHome}
          className="co-w-full co-max-w-[300px]"
        >
          Ir al inicio
        </Button>
      </div>
    </div>
  );
};

BillingDniFallback.displayName = 'BillingDniFallback';

export default BillingDniFallback;
